/* packages/apps/workoutsmart/src/components/chat/effects/InfoProcessingEffectRenderer.jsx */
import React from 'react';
import { Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { alpha } from '@mui/material/styles';

const InfoProcessingEffectRenderer = ({ event }) => {
  return (
    <Chip
      icon={<AutoAwesomeIcon style={{ fontSize: 16 }} />}
      label="Processing Information"
      size="small"
      variant="outlined"
      sx={{
        borderColor: 'success.main',
        color: 'success.main',
        bgcolor: (theme) => alpha(theme.palette.success.main, 0.05),
        height: 'auto', // Allow expansion
        py: 0.5,        // Add vertical padding
        '& .MuiChip-label': { 
            whiteSpace: 'normal', // Wrap text
            overflow: 'visible',
            textOverflow: 'clip',
            display: 'block',
        },
        '& .MuiChip-icon': { color: 'inherit' }
      }}
    />
  );
};

export default InfoProcessingEffectRenderer;